module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/my_comment_gray.4b995.png";